export { default } from "./getAttachmentsFilteredByLicense";
